import React from 'react';
import * as d3 from "d3";
import './CircularBarplot.css';

class CircularBarplot extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            // yAxisAttribute: "name",
            // xAxisAttribute: "value"
        };
        this.circularBarplotRef = React.createRef();
        this.drawChart = this.drawChart.bind(this);
    }

    componentDidMount() {
        this.drawChart();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        this.redrawChart();
    }

    componentWillUnmount() {
        this.clearChart();
    }

    redrawChart() {
        this.clearChart();
        this.drawChart();
    }

    clearChart() {
        d3.selectAll('.tooltip').remove();
        d3.select(".circularBarplot").select("svg").remove();
    }

    drawChart() {
        let margin = {top: 100, right: 100, bottom: 100, left: 100},
            width = 750 - margin.left - margin.right,
            height = 750 - margin.top - margin.bottom,
            innerRadius = 59,
            outerRadius = Math.min(width, height) / 2;   // the outerRadius goes from the middle of the SVG area to the border

        let svg = d3.select(".circularBarplot")
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + (width / 2 + margin.left) + "," + (height / 2 + margin.top) + ")");

        // Scales
        let x = d3.scaleBand()
            .range([0, 2 * Math.PI])    // X axis goes from 0 to 2pi = all around the circle. If I stop at 1Pi, it will be around a half circle
            .align(0)                  // This does nothing
            .domain(this.props.data.map(function(d) { return d.name; })); // The domain of the X axis is the list of states.

        let y = d3.scaleLinear()
            .range([innerRadius, outerRadius])   // Domain will be define later.
            .domain([0, this.props.maxBarHeight]); // Domain of Y is from 0 to the max seen in the data

        svg.append("g")
            .selectAll("g")
            .data(this.props.data)
            .enter()
            .append("g")
            .attr("text-anchor", "middle")
            .call(g => g.selectAll("g")
                .data(y.ticks(5).slice(1))
                .join("g")
                .attr("fill", "none")
                .call(g => g.append("circle")
                    .attr("stroke", "#b4b4b4")
                    .attr("stroke-width", 0.25)
                    .attr("stroke-opacity", 0.5)
                    //.attr("stroke-dasharray", "2,2")
                    .attr("r", y)
                    .attr("shape-rendering", "geometricPrecision"))
                .call(g => g.append("text")
                    .attr("y", d => -y(d))
                    //.attr("dy", "0.35em")
                    .attr("dy", "-1px")
                    .attr("stroke", "#b4b4b4")
                    .attr("stroke-width", 0.2)
                    .attr("font-size", "12px")
                    .text(y.tickFormat(1, "s"))
                    .clone(true)
                    .attr("fill", "#000"))
            );

        let tooltipDiv = d3.select("body").append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);

        // Add the bars
        svg.append("g")
            .selectAll("path")
            .data(this.props.data)
            .enter()
            .append("path")
            .attr("fill", "#2299dd")
            .attr("d", d3.arc()     // imagine your doing a part of a donut plot
                .innerRadius(innerRadius)
                .outerRadius(function(d) { return y(d['value']); })
                .startAngle(function(d) { return x(d.name); })
                .endAngle(function(d) { return x(d.name) + x.bandwidth(); })
                .padAngle(0.01)
                .padRadius(innerRadius))
            .on("mouseover", function(d) {
                tooltipDiv.transition()
                    .duration(200)
                    .style("opacity", 0.85);
                tooltipDiv.html(d.name + "<br/>" + d.value)
                    .style("left", (d3.event.pageX) + "px")
                    .style("top", (d3.event.pageY - 28) + "px");
                d3.select(this)
                    .attr("fill", "#146fa3");
            })
            .on("mouseout", function(d) {
                tooltipDiv.transition()
                    .duration(500)
                    .style("opacity", 0);
                d3.select(this)
                    .attr("fill", "#2299dd");
            });

        // Add the labels
        let labelRadius = 280;
        svg.append("g")
            .selectAll("g")
            .data(this.props.data)
            .enter()
            .append("g")
            .attr("text-anchor", function(d) { return (x(d.name) + x.bandwidth() / 2 + Math.PI) % (2 * Math.PI) < Math.PI ? "end" : "start"; })
            .attr("transform", function(d) { return "rotate(" + ((x(d.name) + x.bandwidth() / 2) * 180 / Math.PI - 90) + ")"+"translate(" + labelRadius + ",0)"; })
            .append("text")
            .text(function(d) { return(d.name) })
            .attr("transform", function(d) { return (x(d.name) + x.bandwidth() / 2 + Math.PI) % (2 * Math.PI) < Math.PI ? "rotate(180)" : "rotate(0)"; })
            .style("font-size", "11px")
            .attr("alignment-baseline", "middle")
            .attr("d", "m0 " + -labelRadius + " a" + labelRadius + " " + labelRadius + " 0 1,1 -0.01 0");
    }

    render() {
        return <div className="circularBarplot" ref={this.circularBarplotRef}/>;
    }
}

export default CircularBarplot;


// WEBPACK FOOTER //
// ./src/main/content/bar-chart/CircularBarplot.js